import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {RelatedFilesTable} from './table/relatedFilesTable'
import {FC} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'

interface props {
  data?: any
}

const RelatedFiles = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <div className='mt-5'>
        <KTCard>
          <RelatedFilesTable />
        </KTCard>
      </div>
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const RelatedFilesWrapper: FC<props> = ({data}) => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <RelatedFiles />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export {RelatedFilesWrapper}
